export default __webpack_public_path__ + "static/media/LeagueSpartan-Bold.ce94841c.woff";